import {
  acquireWhatIfsLoadingSpinner,
  releaseWhatIfsLoadingSpinner,
  setErrors,
  updateWhatIfsData,
} from '../../WhatIfsActions';
import {
  invalidateFinancialPlanQuery,
  invalidateLongevityAnalysis,
  invalidateMarketScenariosQuery,
  invalidateSocialSecurity,
} from '../../../FinancialPlanOPL/Goals/helpers/legacyWhatIfsFinancialPlanHelpers';

export const storeTheOptimizationResults = (
  dispatch,
  clientId,
  goalId,
  whatIfType,
  backendObject,
) => {
  dispatch(updateWhatIfsData(clientId, goalId, whatIfType, {
    WhatIf: {
      SocialSecurityStartAgePrincipal: backendObject.SocialSecurityPrincipalStartAge,
      SocialSecurityStartAgeSpouse: backendObject.SocialSecuritySpouseStartAge,
      SocialSecurityUseSpousalBenefit: backendObject.SocialSecurityUseSpousalBenefit,
      SocialSecurityFileForSurvivorBenefits: backendObject.SocialSecurityUseSurvivorBenefits,
    },
  }));
};

export const optimizeSocialSecurity = (mode, clientId, fpId, goalId, whatIfType) => (dispatch) => {
  const { ADV } = window;
  acquireWhatIfsLoadingSpinner(clientId, dispatch)();
  ADV.util
    .request({
      type: 'POST',
      uri: 'Consumer/OptimizeSocialSecurity/GetOptimalSocialSecuritySolution',
      urlParams: {
        clientId,
        fpId,
        mode,
        goalId,
      },
      showSpinner: false,
    })
    .then((response) => {
      if (response.success) {
        dispatch(setErrors(clientId, []));
        storeTheOptimizationResults(
          dispatch,
          clientId,
          goalId,
          whatIfType,
          response.payload.viewData,
        );
      } else {
        dispatch(setErrors(clientId, response.errors));
      }
    })
    .catch(() => {
      dispatch(setErrors(clientId, [ADV.settings.MsgLib.generic_error]));
    })
    .then(
      releaseWhatIfsLoadingSpinner(clientId, dispatch),
      releaseWhatIfsLoadingSpinner(clientId, dispatch),
    );
};

export const applyOptimalSocialSecuritySolution = (
  mode,
  clientId,
  fpId,
  goalId,
  whatIfType,
) => (dispatch) => {
  if (mode === null || mode === undefined) {
    return;
  }

  const { ADV } = window;
  acquireWhatIfsLoadingSpinner(clientId, dispatch)();
  ADV.util
    .request({
      type: 'POST',
      uri: 'Consumer/OptimizeSocialSecurity/ApplyOptimalSocialSecuritySolutionToPlan',
      urlParams: {
        clientId,
        fpId,
        goalId,
        mode,
      },
      showSpinner: false,
    })
    .then((response) => {
      if (response.success) {
        dispatch(setErrors(clientId, []));

        const appliedAges = response.payload && response.payload.viewData
          && response.payload.viewData.AppliedAges;

        if (appliedAges) {
          dispatch(updateWhatIfsData(clientId, goalId, whatIfType, {
            WhatIf: {
              SocialSecurityStartAgePrincipal: appliedAges.PrincipalAge,
              SocialSecurityStartAgeSpouse: appliedAges.SpouseAge,
            },
          }));
        }

        invalidateFinancialPlanQuery({ clientId, fpId });
        invalidateMarketScenariosQuery({ clientId, fpId });
        invalidateLongevityAnalysis({ clientId, fpId });
        invalidateSocialSecurity({ clientId, fpId });
      } else {
        const viewData = (response.payload && response.payload.viewData) || {};
        const fallbackMessages = viewData.ValidationErrors
          || (viewData.Message ? [viewData.Message] : null);
        dispatch(setErrors(clientId, response.errors || fallbackMessages || []));
      }
    })
    .catch(() => {
      dispatch(setErrors(clientId, [ADV.settings.MsgLib.generic_error]));
    })
    .then(
      releaseWhatIfsLoadingSpinner(clientId, dispatch),
      releaseWhatIfsLoadingSpinner(clientId, dispatch),
    );
};

export const optimizeSocialSecurityMock = (
  mode,
  clientId,
  fpId,
  goalId,
  whatIfType,
) => (dispatch) => {
  acquireWhatIfsLoadingSpinner(clientId, dispatch)();
  setTimeout(() => {
    dispatch(setErrors(clientId, []));
    storeTheOptimizationResults(dispatch, clientId, goalId, whatIfType, {
      SocialSecurityPrincipalStartAge: 77,
      SocialSecuritySpouseStartAge: 89,
      SocialSecurityUseSpousalBenefit: true,
      SocialSecurityUseSurvivorBenefits: false,
    });
    releaseWhatIfsLoadingSpinner(clientId, dispatch)();
  }, 500);
};
